<template>
  <!-- eslint-disable -->
  <div>
    <contenedores-add ref="contenedoresAdd" :is-add.sync="isAdd" @saved="getData" />
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col md="3" class="mb-md-0 mb-2">
              <label>Packing list</label>
              <b-form-input v-model="filters.packingList" placeholder="Packing list" @input="filterData" />
            </b-col>
            <b-col md="3" class="mb-md-0 mb-2">
              <label>Origen</label>
              <b-form-input v-model="filters.origin" placeholder="Origen" @input="filterData" />
            </b-col>
            <b-col md="3" class="mb-md-0 mb-2">
              <label>Destino</label>
              <b-form-input v-model="filters.destination" placeholder="Destino" @input="filterData" />
            </b-col>
            <b-col md="3" class="mb-md-0 mb-2">
              <label>Estado</label>
              <b-form-select v-model="filters.status" :options="statusFilterOptions" @change="filterData" />
            </b-col>
            <b-col md="6" class="mt-2">
              <b-button variant="secondary" class="mr-1" @click.prevent="cleanFilters">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span class="align-middle">Limpiar</span>
              </b-button>
            </b-col>
            <b-col class="d-flex align-items-center justify-content-end">
              <b-button variant="primary" class="mt-2" @click="openAdd">
                <span class="text-nowrap">Agregar contenedor</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
        >
          <template #cell(estimatedShippingDate)="data">
            {{ formatDate(data.item.estimatedShippingDate) }}
          </template>

          <template #cell(status)="data">
            <b-badge :variant="statusVariant(data.item.status)">
              {{ statusLabel(data.item.status) }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <b-button size="sm" @click.prevent="items(data.item)" v-b-tooltip.hover.top="'Items'" variant="flat-info">
              <feather-icon icon="BoxIcon" />
            </b-button>
            <b-button size="sm" @click.prevent="validateContainer(data.item)" v-b-tooltip.hover.top="'Validar'" variant="flat-warning">
              <feather-icon icon="CheckSquareIcon" />
            </b-button>
            <b-button size="sm" @click.prevent="edit(data.item)" v-b-tooltip.hover.top="'Editar'" variant="flat-success">
              <feather-icon icon="Edit2Icon" />
            </b-button>
            <b-button size="sm" @click="deleteAction(data.item)" v-b-tooltip.hover.top="'Eliminar'" variant="flat-danger">
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span>{{ totalElements }} Registros en total</span>
            </b-col>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ContainerService from '@/services/ContainerService'
import contenedoresAdd from './contenedoresAdd.vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    contenedoresAdd,
  },
  data() {
    return {
      showLoading: false,
      isAdd: false,
      records: [],
      totalElements: 0,
      sort: 'id',
      order: 'desc',
      filterTimer: null,
      filters: {
        packingList: '',
        origin: '',
        destination: '',
        status: null,
      },
      fields: [
        { key: 'estimatedShippingDate', label: 'Fecha estimada de envio', sortable: false },
        { key: 'packingList', label: 'Packing list', sortable: false },
        { key: 'origin', label: 'Origen', sortable: false },
        { key: 'destination', label: 'Destino', sortable: false },
        { key: 'status', label: 'Estado', sortable: false },
        { key: 'actions', label: 'Acciones' },
      ],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      statusOptions: [
        { value: 1, text: 'REGISTRO SIN EXCEL' },
        { value: 2, text: 'REGISTRO CON EXCEL SIN VALIDAR' },
        { value: 3, text: 'REGISTRO CON EXCEL VALIDADO CON ERRORES' },
        { value: 4, text: 'REGISTRO CON EXCEL VALIDADO SIN ERRORES' },
      ],
      statusFilterOptions: [
        { value: null, text: 'Todos' },
        { value: 1, text: 'REGISTRO SIN EXCEL' },
        { value: 2, text: 'REGISTRO CON EXCEL SIN VALIDAR' },
        { value: 3, text: 'REGISTRO CON EXCEL VALIDADO CON ERRORES' },
        { value: 4, text: 'REGISTRO CON EXCEL VALIDADO SIN ERRORES' },
      ],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    normalizeRows(data) {
      if (Array.isArray(data)) return data
      if (data && Array.isArray(data.rows)) return data.rows
      if (data && Array.isArray(data.data)) return data.data
      if (data && data.data && Array.isArray(data.data.rows)) return data.data.rows
      return []
    },
    normalizeTotal(data, rows) {
      if (data && data.count !== undefined) return data.count
      if (data && data.total !== undefined) return data.total
      if (data && data.totalElements !== undefined) return data.totalElements
      if (data && data.responseFilter && data.responseFilter.total_rows !== undefined) return data.responseFilter.total_rows
      if (data && data.data && data.data.responseFilter && data.data.responseFilter.total_rows !== undefined) return data.data.responseFilter.total_rows
      return rows.length
    },
    buildBackendFilters() {
      const arrayFilters = []

      if (this.filters.packingList !== '') {
        arrayFilters.push({
          keyContains: 'packingList',
          key: 'contains',
          value: this.filters.packingList,
        })
      }

      if (this.filters.origin !== '') {
        arrayFilters.push({
          keyContains: 'origin',
          key: 'contains',
          value: this.filters.origin,
        })
      }

      if (this.filters.destination !== '') {
        arrayFilters.push({
          keyContains: 'destination',
          key: 'contains',
          value: this.filters.destination,
        })
      }

      if (this.filters.status !== null) {
        arrayFilters.push({
          keyContains: 'status',
          key: 'equals',
          value: Number(this.filters.status),
        })
      }

      return arrayFilters
    },
    filterData() {
      this.currentPage = 1
      clearTimeout(this.filterTimer)
      this.filterTimer = setTimeout(() => {
        this.getData()
      }, 350)
    },
    cambioPagina(page) {
      this.currentPage = page
      this.getData()
    },
    changeSizePage() {
      this.currentPage = 1
      this.getData()
    },
    cleanFilters() {
      this.filters = {
        packingList: '',
        origin: '',
        destination: '',
        status: null,
      }
      this.currentPage = 1
      this.getData()
    },
    formatDateForInput(value) {
      if (!value) return ''
      return String(value).slice(0, 10)
    },
    formatDate(value) {
      if (!value) return ''
      const date = String(value).slice(0, 10)
      const parts = date.split('-')
      if (parts.length !== 3) return date
      return `${parts[2]}/${parts[1]}/${parts[0]}`
    },
    statusLabel(status) {
      const option = this.statusOptions.find(item => Number(item.value) === Number(status))
      return option ? option.text : 'SIN ESTADO'
    },
    statusVariant(status) {
      const variants = {
        1: 'secondary',
        2: 'warning',
        3: 'danger',
        4: 'success',
      }
      return variants[Number(status)] || 'secondary'
    },
    openAdd() {
      this.isAdd = true
      this.$refs.contenedoresAdd.getData({})
    },
    items(item) {
      this.$router.push('/contenedores/' + item.id + '/items')
    },
    validateContainer(item) {
      this.$router.push('/contenedores/' + item.id + '/validar')
    },
    async edit(item) {
      this.showLoading = true
      const resp = await ContainerService.getContainer(item.id, this.$store)
      const data = resp && resp.data ? resp.data : item
      this.isAdd = true
      this.$refs.contenedoresAdd.getData(data)
      this.showLoading = false
    },
    async getData() {
      this.records = []
      this.totalElements = 0
      this.showLoading = true
      const arrayFilters = this.buildBackendFilters()
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(arrayFilters)}`
      const resp = await ContainerService.getContainers(url, this.$store)
      if (resp && resp.data) {
        this.records = this.normalizeRows(resp.data)
        this.totalElements = this.normalizeTotal(resp.data, this.records)
      }
      this.showLoading = false
    },
    async deleteAction(item) {
      this.$swal({
        title: 'Desea eliminar este contenedor?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminalo',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) this.deleteData(item.id)
      })
    },
    async deleteData(id) {
      const resp = await ContainerService.deleteContainer(id, this.$store)
      if (resp) {
        this.$swal({
          icon: 'success',
          title: 'Eliminado!',
          text: 'El contenedor ha sido eliminado.',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
        this.currentPage = 1
        this.getData()
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrio un error al eliminar el contenedor.',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      }
    },
  },
}
</script>
